import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { ProductDedicatedResponseTypes } from "../common/response.common";
import { asRemoveHook, asUpdateHook, get, post } from "./common";

export const productDedicated = {
    obtain(id: string) {
        return get<ProductDedicatedResponseTypes.Obtain>(`/product-dedicated/obtain/${id}`);
    },
    formHooks: {
        update(id: string | undefined, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.ProductDedicated.Update.Input) => {
                if (id === undefined) return false;
                return await asUpdateHook(
                    post<typeof data>(`/product-dedicated/update/${id}`, data),
                    isLoading,
                );
            };
        },
        remove(id: string | undefined, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.ProductDedicated.Remove.Input) => {
                if (id === undefined) return false;
                return await asRemoveHook(
                    post<typeof data>(`/product-dedicated/remove/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
